import React, { forwardRef } from 'react';

export interface RadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string;
}

/**
 * KERN Radio Component
 *
 * Usage:
 * <Radio label="Option A" name="options" value="a" />
 * <Radio label="Option B" name="options" value="b" />
 */
export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ label, id, className = '', ...props }, ref) => {
    const radioId = id || `radio-${label.toLowerCase().replace(/\s+/g, '-')}-${props.value}`;

    return (
      <div className={`kern-form-check ${className}`}>
        <input ref={ref} className="kern-form-check__radio" id={radioId} type="radio" {...props} />
        <label className="kern-label" htmlFor={radioId}>
          {label}
        </label>
      </div>
    );
  }
);

Radio.displayName = 'Radio';

export default Radio;
